export const calcTotalAmount = (selectedBills) => {
  // Handle null, undefined, or non-array inputs safely
  if (!selectedBills || !Array.isArray(selectedBills) || selectedBills.length === 0) {
    return 0;
  }
  
  return selectedBills.reduce((accumulator, currentValue) => {
    if (!currentValue) return accumulator;
    
    const numericValue = parseFloat(currentValue.amount); // Convert the amount to a float
    if (!isNaN(numericValue)) {
      // Check if the conversion is successful and it's a valid number
      return accumulator + numericValue;
    }
    return accumulator; // If it's not a valid number, just return the accumulator unchanged
  }, 0);
};
